const colLinks = [
  { id: 'hero', label: '网站首页' },
  { id: 'hot', label: '今日热梗' },
  { id: 'library', label: '表情大全' },
  { id: 'gif', label: '动图专区' },
];

const sceneLinks = [
  '震惊吃瓜表情',
  '无语围观表情',
  '偷笑看戏表情',
  '蹲后续表情包',
  '阴阳怪气表情',
  '吃瓜群众动图',
];

export default function Footer() {
  const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="bg-secondary-100/60 py-12">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                <i className="ri-water-flash-line" />
              </span>
              <span className="font-heading text-xl text-foreground-950">
                吃瓜<span className="text-primary-600">表情</span>站
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              专为吃瓜群众打造的趣味表情包配图库。海量吃瓜专用表情、动图每日上新，覆盖各种围观场景，让你的聊天更有梗、吃瓜更带劲。
            </p>
            <p className="mt-4 text-sm text-foreground-700">
              内容合作 / 投稿：{' '}
              <a href="mailto:hello@chigua-meme.cn" className="text-primary-600 hover:underline">
                hello@chigua-meme.cn
              </a>
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base text-foreground-900">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {colLinks.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => go(l.id)}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-base text-foreground-900">热门场景</h4>
            <ul className="mt-4 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
              {sceneLinks.map((s) => (
                <li key={s}>
                  <button
                    onClick={() => go('library')}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-200/80 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 吃瓜表情站 · 表情仅供娱乐围观使用
          </p>
          <div className="flex items-center gap-3">
            <a href="mailto:hello@chigua-meme.cn" aria-label="联系邮箱" className="flex h-8 w-8 items-center justify-center rounded-md bg-background-50 text-foreground-700 hover:bg-background-200">
              <i className="ri-mail-line" />
            </a>
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-50 text-foreground-700 hover:bg-background-200">
              <i className="ri-wechat-line" />
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-50 text-foreground-700 hover:bg-background-200">
              <i className="ri-qq-line" />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}